// extracted by css-extract-rspack-plugin
export default {"form":"DUENmhTQhAn6sqP9__form___","filterSection":"aLctl5eyxv4tzWmA__filterSection___"};